export enum ELocales {
  RU = 'ru',
  EN = 'en',
  ZH = 'zh',
  KA = 'ka',
  TR = 'tr',
  KK = 'kk',
  TG = 'tg',
}

export enum EZoneCodes {
  RU = 'ru',
  CN = 'cn',
  GE = 'ge',
  BY = 'by',
  TR = 'tr',
  TJ = 'tj',
  ET = 'et',
  KG = 'kg',
  AM = 'am',
  KZ = 'kz',
  UZ = 'uz',
}

export enum ECountries {
  RU = 'ru',
  EN = 'en',
  ZH = 'zh',
  GE = 'ge',
  TR = 'tr',
  BY = 'by',
  CN = 'cn',
  KZ = 'kz',
  TJ = 'tj',
}

export type TCountryConfig = {
  defaultLanguage: ELocales;
};

export enum EColors {
  RICH_GREY = 'rich-grey',
  NORMAL_GREY = 'normal-grey',
  DEFAULT = 'default',
  BLACK = 'black',
  WHITE = 'white',
  BLUE_500 = 'blue-500',
  GREY_200 = 'grey-200',
  TEXT_SECONDARY = 'text-secondary',
  ORANGE = 'orange',
  PINK = 'pink',
  PINK_2 = 'pink-2',
}

export enum EBlocksNames {
  HOW_START = 'howStart',
  LEARN_INFO = 'learnInfo',
  COPYRIGHT_APPEAL = 'copyright_appeal',
  OFFER = 'offer',
  ACCESS_RECOVERY = 'access_recovery',
  PRIVACY_POLICY = 'privacy_policy',
  OUR_PARTNERS = 'our_partners',
  MARKETPLACE = 'marketplace',
}
